import { Text, Tooltip } from 'farmhub-ui-core';

import { formatAppearPhoneNumber } from 'utils';

type PhoneNumberTextProps = {
  phoneNumber?: string;
  size?: string;
};

const PhoneNumberText = ({
  phoneNumber,
  size = 'xxs',
}: PhoneNumberTextProps): React.ReactElement => (
  <Tooltip title={formatAppearPhoneNumber(phoneNumber)}>
    <Text
      color="secondary"
      lineHeight="18px"
      lineNumber={1}
      size={size}
      styles={{ fontStyle: phoneNumber ? 'normal' : 'italic' }}
    >
      {formatAppearPhoneNumber(phoneNumber)}
    </Text>
  </Tooltip>
);

export default PhoneNumberText;
